















































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import PopGallery from "@/components/popGallery/popGallery.vue";
import Button from "@/components/button/Button.vue";
import LoginButton from "@/components/loginButton/LoginButton.vue";
import InputField from "@/components/input/InputField.vue";
import * as types from "@/store/constants/types";
import { isEmail } from "@/utils/lodash";
import BakcPress from "@/utils/backPress";
import { LITE_SERCAH_POP } from "@/utils/backPress";
import { isIos } from "@/utils/lodash";
import {initialProcessState} from '@/utils/initialProcessState'
import EventBus from "@/utils/eventBus";

@Component({
  components: {
    PopGallery,
    LoginButton,
    InputField
  }
})
export default class LiteSearchUser extends Vue {
  //   @Prop({ default: "default value" })
  //   private propB?: string;
  @Action(types.ROUTER_PUSH)
  private routerPush: any;
  @Action(types.ADD_USER)
  private addUser: any;
  @Action(types.SHAKE_PLAY)
  private shakePlay: any;
  @Mutation(types.LITE_SEARCH_POP_SHOW)
  private liteSearchPopShow: any;
  @Getter(types.LITE_SEARCH_POP_SHOW_STATUS)
  private liteSearchPopShowStatus: any;
  private accountText: any = "";
  private popShow: boolean = false;
  private manualClose: boolean = true; // 手动关闭还是自动关闭
  private buttonStatus: string = "normal";

  private inputDom: any;

  private showWarnLine: boolean = false;

  @Watch("liteSearchPopShowStatus", { immediate: true })
  private changePop(val: boolean, oldVal: boolean) {
    //watch 开启
    if (val) {
      this.popShow = true;
      BakcPress.listen({
        key: LITE_SERCAH_POP,
        fn: () => {
          this.popShow = false;
        }
      });
      if (!isIos()) {
        //安卓才能自动focus:
        setTimeout(() => {
          this.inputDom = document.getElementById("input-dom");
          this.inputDom ? this.inputDom.focus() : void 0;
        }, 150);
      }
    }
  }

  @Watch("popShow", { immediate: true })
  private popShowChange(val: boolean, oldVal: boolean) {
    //watch 关闭

    if (!val) {
      this.liteSearchPopShow(false);
      BakcPress.destroy(LITE_SERCAH_POP);
      // 如果是手动关闭并且存在未购买的recommend_offer
      if (initialProcessState.recommendOffer && this.manualClose) {
        EventBus.$emit(
                "recommend-offer-show",
                initialProcessState.recommendOffer
        );
      }
    }
  }
  //
  // @Watch("accountText", { immediate: true })
  // private accountChange(val: string, oldVal: string) {
  //   // val !== ""
  //   //   ? (this.buttonStatus = "normal")
  //   //   : (this.buttonStatus = "disable");
  // }

  private clickLogin() {
    this.popShow = false;
    this.manualClose = false;
    this.routerPush({
      name: "Login",
      params: {
        routerTransition: "up"
      }
    });
  }

  private redLineShow() {
    this.showWarnLine = true;
    setTimeout(() => {
      this.showWarnLine = false;
    }, 2000);
  }

  private clickStarted() {
    this.manualClose = false;
    this.$Toast.show({
      type: "loading",
      content: "processing..",
      duration: "infinite"
    });
    // this.accountText = this.accountText.trim(); //去除前后的空格
    this.accountText = this.accountText.replace(/\s*/g,"");

    //校验：
    if (this.accountText === "") {
      this.$Toast.show({
        type: "warning",
        content: "Please enter your Instagram username first.",
        duration: 2000
      });
      this.shakePlay(20, 0);
      this.redLineShow();
      return;
    }

    if (isEmail(this.accountText)) {
      this.$Toast.show({
        type: "warning",
        content: "Please enter your Instagram username,not email.",
        duration: 2000
      });
      this.shakePlay(20, 0);
      this.redLineShow();
      return;
    }

    this.addUser({
      username: this.accountText,
      userType: "search"
    })
      .then((result: any) => {
        console.log("clickStarted finishi");
        this.$Toast.hide();
        this.popShow = false;
        this.manualClose = false;
      })
      .catch((error: any) => {
        console.log("clickStarted error:", error);
        this.$Toast.hide();
        this.shakePlay(20, 0);
        this.redLineShow();
        if (error.error && error.error.NSLocalizedDescription) {
          this.$Toast.show({
            type: "warning",
            content: "Please check your network and try again later",
            duration: 2000
          });
        } else {
          this.$Toast.show({
            type: "warning",
            content: "Please check your username and try again.",
            duration: 2000
          });
        }
      });
  }


  private created() {}

  private mounted() {}
}
